declare global {
	interface Window {
		/**
		 * This is for accessing clipboardData in Internet Explorer.
		 * Does not work in Chrome or Firefox.
		 */
		clipboardData?: DataTransfer;
	}
}

export class Clipboard {
	/**
	 * copy will copy the given text to the clipboard.
	 *
	 * - https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
	 * - https://developers.google.com/web/updates/2015/04/cut-and-copy-commands?hl=en
	 */
	public static copy(text: string): void {
		if (!text) {
			// NOTE: Jake: 2019-02-20 - Chrome 72
			// When testing this, Chrome would not override the clipboard
			// with a blank string which is a bit confusing.
			// Umit and I agreed that the behaviour should probably be that it copies a string with 1 space.
			text = ' ';
		}

		const copyFn = (e: ClipboardEvent) => {
			e.preventDefault();
			if (e.clipboardData) {
				e.clipboardData.setData('text/plain', text);
			} else if (window.clipboardData) {
				window.clipboardData.setData('Text', text);
			}
			document.body.removeEventListener('copy', copyFn);
		};
		document.body.addEventListener('copy', copyFn);

		// NOTE: Jake: 2019-02-20
		// This function can only be called as the direct result of a user action.
		// ie. click event handler.
		// See: https://developers.google.com/web/updates/2015/04/cut-and-copy-commands?hl=en
		document.execCommand('copy');
	}
}
